export const districtsArray = [
  'Legnica',
  'Wałbrzych',
  'Wrocław',
  'Bydgoszcz',
  'Toruń',
  'Lublin',
  'Chełm',
  'Zielona Góra',
  'Łódź',
  'Piotrków Trybunalski',
  'Sieradz',
  'Kraków I (południe)',
  'Kraków II (północ)',
  'Nowy Sącz',
  'Tarnów',
  'Płock',
  'Radom',
  'Siedlce',
  'Warszawa I (miasto)',
  'Warszawa II (okręg)',
  'Opole',
  'Krosno',
  'Rzeszów',
  'Białystok',
  'Gdańsk',
  'Gdynia',
  'Bielsko-Biała',
  'Częstochowa',
  'Gliwice',
  'Rybnik',
  'Katowice',
  'Sosnowiec',
  'Kielce',
  'Elbląg',
  'Olsztyn',
  'Kalisz',
  'Konin',
  'Piła',
  'Poznań',
  'Koszalin',
  'Szczecin',
];

export const seatsArray = [
  12,
  8,
  14,
  12,
  13,
  15,
  12,
  12,
  10,
  9,
  12,
  8,
  14,
  10,
  9,
  10,
  9,
  12,
  20,
  12,
  12,
  11,
  15,
  14,
  12,
  14,
  9,
  7,
  9,
  9,
  12,
  9,
  16,
  8,
  10,
  12,
  9,
  9,
  10,
  8,
  12,
];

export const electionResults = `"Numer okręgu";"Nazwa";"Komisja otrzymała kart do głosowania";"Liczba wyborców uprawnionych do głosowania";"Nie wykorzystano kart do głosowania";"Liczba wyborców, którym wydano karty do głosowania";"Liczba wyborców głosujących przez pełnomocnika";"Liczba wyborców głosujących na podstawie zaświadczenia o prawie do głosowania";"Liczba wyborców, którym wysłano pakiety wyborcze";"Liczba otrzymanych kopert zwrotnych";"Liczba kopert zwrotnych, w których nie było oświadczenia o osobistym i tajnym oddaniu głosu";"Liczba kopert zwrotnych, w których oświadczenie nie było podpisane";"Liczba kopert zwrotnych, w których nie było koperty na kartę do głosowania";"Liczba kopert zwrotnych, w których znajdowała się niezaklejona koperta na kartę do głosowania";"Liczba kopert na kartę do głosowania wrzuconych do urny";"Liczba kart wyjętych z urny";"W tym liczba kart wyjętych z kopert na kartę do głosowania";"Liczba kart nieważnych";"Liczba kart ważnych";"Liczba głosów nieważnych";"W tym z powodu postawienia znaku „X” obok nazwiska dwóch lub większej liczby kandydatów z różnych list";"W tym z powodu niepostawienia znaku „X” obok nazwiska żadnego kandydata";"W tym z powodu postawienia znaku „X” wyłącznie obok nazwiska kandydata na liście, której rejestracja została unieważniona";"Liczba głosów ważnych oddanych łącznie na wszystkie listy kandydatów";"KOALICYJNY KOMITET WYBORCZY KOALICJA OBYWATELSKA PO .N IPL ZIELONI - ZPOW-601-6/19";"KOMITET WYBORCZY AKCJA ZAWIEDZIONYCH EMERYTÓW RENCISTÓW - ZPOW-601-21/19";"KOMITET WYBORCZY KONFEDERACJA WOLNOŚĆ I NIEPODLEGŁOŚĆ - ZPOW-601-5/19";"KOMITET WYBORCZY POLSKIE STRONNICTWO LUDOWE - ZPOW-601-19/19";"KOMITET WYBORCZY PRAWICA - ZPOW-601-20/19";"KOMITET WYBORCZY PRAWO I SPRAWIEDLIWOŚĆ - ZPOW-601-9/19";"KOMITET WYBORCZY SKUTECZNI PIOTRA LIROYA-MARCA - ZPOW-601-17/19";"KOMITET WYBORCZY SOJUSZ LEWICY DEMOKRATYCZNEJ - ZPOW-601-1/19";"KOMITET WYBORCZY WYBORCÓW KOALICJA BEZPARTYJNI I SAMORZĄDOWCY - ZPOW-601-10/19";"KOMITET WYBORCZY WYBORCÓW MNIEJSZOŚĆ NIEMIECKA - ZPOW-601-15/19"
1;"Legnica";697907;757942;259666;438239;490;5597;37;35;6;1;0;0;28;438194;28;84;438110;5674;3655;2019;0;432436;108191;"";25319;31006;"";183364;"";71061;13495;""
2;"Wałbrzych";470923;514042;183904;287009;417;4854;44;42;2;1;0;0;39;287015;39;37;286978;3976;2688;1288;0;283002;90812;"";15346;20528;"";114728;"";34957;6631;""
3;"Wrocław";895625;1001757;235423;660182;630;8921;82;80;2;0;0;0;78;660117;78;90;660027;5572;3230;2342;0;654455;214629;"";48775;42269;"";226915;"";100843;21024;""
4;"Bydgoszcz";712403;778558;245980;466427;480;3538;77;75;6;0;0;0;69;466407;69;13;466394;6412;4389;2023;0;459982;142844;"";32406;41497;"";167550;"";69763;5922;""
5;"Toruń";742540;813079;284127;458383;575;5302;64;64;0;0;0;0;64;458408;64;63;458345;6015;3914;2101;0;452330;119526;"";28625;49225;"";182648;"";67076;5230;""
6;"Lublin";862523;938157;291363;571149;952;4939;69;69;4;0;1;0;64;571138;64;34;571104;5507;3176;2331;0;565597;109185;"";40012;51474;"";313284;"";44152;7490;""
7;"Chełm";690813;747526;284118;406690;782;3251;28;27;2;0;0;0;25;406678;25;18;406660;5342;3530;1812;0;401318;59401;"";23439;47604;"";238802;"";27404;4668;""
8;"Zielona Góra";713950;776935;269383;444548;465;3003;51;51;3;0;0;0;48;444492;48;64;444428;6511;4369;2142;0;437917;136955;"";31490;50943;"";150188;"";68341;"";""
9;"Łódź";566005;612800;147178;418814;414;2941;83;81;2;1;0;0;78;418745;78;106;418639;3099;1632;1467;0;415540;148830;"";27627;18828;"";136731;"";83524;"";""
10;"Piotrków Trybunalski";521078;567583;170181;350868;399;1725;21;20;0;0;0;0;20;350848;20;16;350832;4506;2973;1533;0;346326;54160;"";23427;36151;"";194658;"";37930;"";""
11;"Sieradz";701279;765170;234986;466274;531;2206;22;20;0;0;0;0;20;466190;20;35;466155;5916;3738;2178;0;460239;94268;"";27054;47373;"";229245;"";55116;7183;""
12;"Kraków I (południe)";465480;508888;145551;319925;402;1780;26;26;1;0;0;0;25;319928;25;23;319905;3691;2335;1356;0;316214;72869;"";22334;24996;"";169106;"";26909;"";""
13;"Kraków II (północ)";862812;953716;208617;654148;733;9912;133;129;2;0;0;0;127;654130;127;152;653978;4691;2379;2312;0;649287;197930;"";51855;47219;1765;256847;"";84457;9214;""
14;"Nowy Sącz";576255;621580;201521;374708;465;10724;45;45;2;0;1;0;42;374703;42;3;374700;4501;2801;1700;0;370199;51183;"";25747;27203;"";243583;"";22483;"";""
15;"Tarnów";533024;580610;181794;351124;445;1909;31;31;0;0;0;0;31;351098;31;23;351075;3987;2481;1506;0;347088;48597;"";24695;46333;"";206845;"";20618;"";""
16;"Płock";594543;651882;218513;376018;516;1885;23;21;0;0;0;0;21;376000;21;3;375997;5436;3388;2048;0;370561;62429;"";19405;56227;"";194371;"";32448;5681;""
17;"Radom";511886;556858;173078;338801;442;1728;28;26;1;0;0;0;25;338782;25;15;338767;3758;2152;1606;0;335009;57449;"";19724;34185;"";193709;2503;24884;2555;""
18;"Siedlce";684696;752277;225904;458770;599;2582;25;24;1;0;0;0;23;458762;23;10;458752;5846;3347;2499;0;452906;63124;1412;29390;54085;"";270641;"";29235;5019;""
19;"Warszawa I (miasto)";1670076;1742400;279264;1390641;1164;38061;194;184;21;2;0;0;164;1389970;164;447;1389523;7606;3476;4130;0;1381917;581077;"";103843;65683;"";379880;"";251434;"";""
20;"Warszawa II (okręg)";774331;856128;170104;604224;507;5330;96;95;2;1;0;0;92;604128;92;68;604060;5333;2964;2369;0;598727;171286;"";39675;51484;"";244823;"";78348;13111;""
21;"Opole";719838;779536;307303;412525;468;2414;29;29;0;0;0;0;29;412469;29;17;412452;6013;4104;1909;0;406439;108570;"";23176;41901;"";152999;"";47699;"";32094
22;"Krosno";648912;701642;253336;395573;766;6939;31;31;2;0;0;0;29;395556;29;7;395549;4968;3298;1670;0;390581;62246;"";26615;30655;"";247488;"";23577;"";""
23;"Rzeszów";907022;988338;312711;594307;850;4375;41;40;1;0;0;0;39;594277;38;19;594258;5472;3172;2300;0;588786;84703;"";48600;45868;"";367268;3530;38817;"";""
24;"Białystok";848752;922518;323189;525568;895;3680;62;62;2;1;1;0;58;525560;58;17;525543;4965;2770;2195;0;520578;109527;1775;36207;48566;"";270888;2272;47342;4001;""
25;"Gdańsk";753982;831651;219856;534255;500;8501;99;99;4;1;0;0;94;534071;94;46;534025;5196;3218;1978;0;528829;218484;"";38153;31203;"";169753;"";71236;"";""
26;"Gdynia";872627;935164;285392;587272;525;7362;100;99;13;2;0;0;84;587233;84;43;587190;6468;3692;2776;0;580722;208208;"";42364;46132;"";211582;"";72436;"";""
27;"Bielsko-Biała";569412;605360;176394;393014;503;4575;38;38;5;0;0;0;33;392959;33;12;392947;3691;2085;1606;0;389256;105876;"";28900;27752;"";182027;"";44701;"";""
28;"Częstochowa";431901;470075;144067;287824;330;1864;42;40;0;0;0;0;40;287791;40;14;287777;3260;2141;1119;0;284517;64374;"";17278;24704;"";125990;"";44354;7817;""
29;"Gliwice";534418;581805;190114;344301;334;1759;30;29;1;0;0;0;28;344292;28;8;344284;3637;2074;1563;0;340647;111078;"";26114;20408;"";128579;"";45583;8885;""
30;"Rybnik";524127;558077;186917;337185;353;1107;27;27;1;0;0;0;26;337148;26;18;337130;3294;1901;1393;0;333836;92493;"";23939;18816;"";161160;"";32300;5128;""
31;"Katowice";677792;740858;203558;474223;482;2886;52;51;2;1;0;1;47;474144;47;21;474123;4490;2516;1974;0;469633;174683;"";34416;20512;"";184030;"";55992;"";""
32;"Sosnowiec";491534;537371;153020;338510;355;1516;42;41;2;1;0;1;37;338481;37;7;338474;3043;1874;1169;0;335431;99499;"";21650;16263;"";124553;"";73466;"";""
33;"Kielce";927566;998797;351202;576353;899;4587;33;32;0;0;1;0;31;576308;31;32;576276;6385;4016;2369;0;569891;94880;"";33895;56289;"";314455;8273;56699;5400;""
34;"Elbląg";447186;484489;191809;255374;264;1772;20;20;2;1;1;0;16;255370;16;11;255359;4540;3263;1277;0;250819;71320;"";14187;27319;"";102478;"";29196;6319;""
35;"Olsztyn";569496;619669;232809;336643;393;3804;33;32;4;0;0;1;27;336647;27;12;336635;4951;3096;1855;0;331684;87780;"";23134;43758;"";128760;2340;45912;"";""
36;"Kalisz";720895;782102;254203;466690;388;1897;56;56;2;1;1;0;52;466669;52;8;466661;7509;5005;2504;0;459152;113489;"";30177;58759;"";195053;"";61674;"";""
37;"Konin";556500;606633;198030;358457;312;1504;33;31;2;0;0;0;29;358437;29;21;358416;5375;3773;1602;0;353041;72295;2261;23810;34620;"";166965;"";53090;"";""
38;"Piła";550788;601148;195405;355382;367;1825;18;18;0;0;0;0;18;355334;18;13;355321;6270;4437;1833;0;349051;106810;"";23123;48371;"";124392;"";46355;"";""
39;"Poznań";634485;709238;115525;518935;399;6156;61;60;4;0;1;0;55;518801;55;135;518666;4139;2333;1806;0;514527;233474;"";34024;31875;"";130319;"";84835;"";""
40;"Koszalin";456863;498780;180203;276658;342;7719;27;27;1;1;0;0;25;276638;25;13;276625;4914;3470;1444;0;271711;87799;"";16259;25632;"";100078;"";41943;"";""
41;"Szczecin";732615;802417;256060;476544;533;6380;51;50;5;1;0;1;44;476444;44;127;476317;5788;3698;2090;0;470529;168022;"";30744;34807;"";165200;"";71756;"";""`;

export const parties = [
  { name: 'PiS', threshold: 5 },
  { name: 'KO', threshold: 8 },
  { name: 'Lewica', threshold: 5 },
  { name: 'PSL', threshold: 5 },
  { name: 'Konfederacja', threshold: 5 },
  { name: 'MN', threshold: 0 },
];
